var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3 5.5L8 10.5L13 5.5","stroke":"currentColor"}));
}

ArrowDown.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
